import RequestManager from "../../../requests/RequestManager";
import StatisticsTask from "../../../requests/tasks/sports/statisticsTask";
import logger from 'src/utils/logger/logger';

export default async function getStatistics (idLeague) {
    const statisticsTask = new StatisticsTask(idLeague);
    try {
        const response = await RequestManager.addRequest(statisticsTask);
        if(!response) return null;
        return response.data.statistics
    } catch (error) {
        logger.error('Error fetching matches:', error);
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/EstadisticasJuegos/getStatistics.js